import React, { useEffect, useState } from "react";
import { useSession } from "../SessionContext";

const IP = "https://reportes.aux-rolplay.com";
//const IP = "http://localhost:5020";

const Dashboard = () => {
  const endpoint = `${IP}/salinas/lacoste_dashboard`;
  const { id_user } = useSession();
  const [usersData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedUserDetail, setSelectedUserDetail] = useState(null);
  const [progressData, setProgressData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [levelStats, setLevelStats] = useState({
    bajo: 0,
    medio: 0,
    alto: 0,
  });
  const [accountStats, setAccountStats] = useState({
    activo: 0,
    inactivo: 0,
  });

  useEffect(() => {
    const fetchUsersAndDetails = async () => {
      setIsLoading(true);
      try {
        const res = await fetch(endpoint);
        const data = await res.json();
        const users = data.result || [];
        setUsersData(users);

        const stats = {
          bajo: 0,
          medio: 0,
          alto: 0,
        };
        const accountStats = {
          activo: 0,
          inactivo: 0,
        };

        users.forEach((user) => {
          const estado = user.Estado.toLowerCase();
          if (accountStats.hasOwnProperty(estado)) {
            accountStats[estado]++;
          }
          if (estado === "activo") {
            const nivel = user.Nivel.toLowerCase();
            if (stats.hasOwnProperty(nivel)) {
              stats[nivel]++;
            }
          }
        });

        setLevelStats(stats);
        setAccountStats(accountStats);
      } catch (err) {
        setUsersData([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (id_user) fetchUsersAndDetails();
  }, [id_user]);

  const calculatePercentage = (count) => {
    return ((count / usersData.length) * 100).toFixed(1);
  };

  if (isLoading)
    return <div className="text-center py-8">Cargando datos...</div>;

  return (
    <div className="w-full p-5">
      {/* Alerta */}
      <div className="mb-6">
        <div className="p-4 border border-purple-700 bg-purple-100 rounded-xl text-purple-800 text-sm flex items-center gap-2">
          <i className="fas fa-info-circle text-purple-600"></i>
          <p>
            Para actualizar la información mostrada en la tabla, por favor
            recargue la página.
          </p>
        </div>
      </div>

      {/* Indicadores de Nivel y Estado */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-8">
        {/* Tarjeta Cuentas Activas */}
        <div className="bg-[#00BB77] text-gray-200 rounded-xl shadow-lg p-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">Cuentas Activas</h3>
            <div className="flex items-baseline">
              <span className="text-4xl font-bold">{accountStats.activo}</span>
              <span className="ml-2 text-lg">/{usersData.length}</span>
            </div>
            <div className="mt-3">
              <div className="w-full h-2 bg-white bg-opacity-[.50] rounded-full overflow-hidden">
                <div
                  className="h-full bg-white"
                  style={{
                    width: `${calculatePercentage(accountStats.activo)}%`,
                  }}
                ></div>
              </div>
              <p className="text-sm mt-1">
                Representación:{" "}
                <span className="font-medium">
                  {calculatePercentage(accountStats.activo)}%
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Tarjeta Cuentas Inactivas */}
        <div className="bg-[#33343A] text-gray-200 rounded-xl shadow-lg p-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">Cuentas Inactivas</h3>
            <div className="flex items-baseline">
              <span className="text-4xl font-bold">
                {accountStats.inactivo}
              </span>
              <span className="ml-2 text-lg">/{usersData.length}</span>
            </div>
            <div className="mt-3">
              <div className="w-full h-2 bg-white bg-opacity-[.50] rounded-full overflow-hidden">
                <div
                  className="h-full bg-white"
                  style={{
                    width: `${calculatePercentage(accountStats.inactivo)}%`,
                  }}
                ></div>
              </div>
              <p className="text-sm mt-1">
                Representación:{" "}
                <span className="font-medium">
                  {calculatePercentage(accountStats.inactivo)}%
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="bg-[#991b1b] text-gray-200 rounded-xl shadow-lg p-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">Nivel Bajo</h3>
            <div className="flex items-baseline">
              <span className="text-4xl font-bold">{levelStats.bajo}</span>
              <span className="ml-2 text-lg">/{usersData.length}</span>
            </div>
            <div className="mt-3">
              <div className="w-full h-2 bg-white bg-opacity-[.50] rounded-full overflow-hidden">
                <div
                  className="h-full bg-white"
                  style={{ width: `${calculatePercentage(levelStats.bajo)}%` }}
                ></div>
              </div>
              <p className="text-sm mt-1">
                Representación:{" "}
                <span className="font-medium">
                  {calculatePercentage(levelStats.bajo)}%
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Tarjeta Nivel Medio */}
        <div className="bg-[#991b1b] text-gray-200 rounded-xl shadow-lg p-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">Nivel Medio</h3>
            <div className="flex items-baseline">
              <span className="text-4xl font-bold">{levelStats.medio}</span>
              <span className="ml-2 text-lg">/{usersData.length}</span>
            </div>
            <div className="mt-3">
              <div className="w-full h-2 bg-white bg-opacity-[.50] rounded-full overflow-hidden">
                <div
                  className="h-full bg-white"
                  style={{ width: `${calculatePercentage(levelStats.medio)}%` }}
                ></div>
              </div>
              <p className="text-sm mt-1">
                Representación:{" "}
                <span className="font-medium">
                  {calculatePercentage(levelStats.medio)}%
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Tarjeta Nivel Alto */}
        <div className="bg-[#991b1b] text-gray-200 rounded-xl shadow-lg p-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">Nivel Alto</h3>
            <div className="flex items-baseline">
              <span className="text-4xl font-bold">{levelStats.alto}</span>
              <span className="ml-2 text-lg">/{usersData.length}</span>
            </div>
            <div className="mt-3">
              <div className="w-full h-2  bg-white bg-opacity-[.50] rounded-full overflow-hidden">
                <div
                  className="h-full bg-white"
                  style={{ width: `${calculatePercentage(levelStats.alto)}%` }}
                ></div>
              </div>
              <p className="text-sm mt-1">
                Representación:{" "}
                <span className="font-medium">
                  {calculatePercentage(levelStats.alto)}%
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla */}
      <div className="w-full rounded-xl overflow-hidden bg-white shadow-lg">
        <div className="overflow-x-auto max-h-[600px] scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200 hover:scrollbar-thumb-gray-800 scrollbar-thumb-rounded-md scrollbar-track-rounded-md">
          <table className="w-full">
            <thead className="bg-gradient-to-r from-[#991b1b] to-[#dc2626] text-white sticky top-0 z-10">
              <tr>
                <th className="px-4 py-3 text-[13px] font-medium text-center whitespace-nowrap">
                  Correo
                </th>
                <th className="px-4 py-3 text-[13px] font-medium text-center whitespace-nowrap">
                  Estado
                </th>
                <th className="px-4 py-3 text-[13px] font-medium text-center whitespace-nowrap">
                  Nivel
                </th>
                <th className="px-4 py-3 text-[13px] font-medium text-center whitespace-nowrap">
                  Nombre
                </th>
                <th className="px-4 py-3 text-[13px] font-medium text-center whitespace-nowrap">
                  Progreso
                </th>
                <th className="px-4 py-3 text-[13px] font-medium text-center whitespace-nowrap">
                  Promedio
                </th>
                <th className="px-4 py-3 text-[13px] font-medium text-center whitespace-nowrap">
                  Fecha de Creación
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {usersData.map((row, index) => (
                <tr
                  key={index}
                  className="transition-all duration-200 hover:bg-gradient-to-r hover:from-red-50 hover:to-red-100 hover:shadow-sm even:bg-gray-50/50"
                >
                  <td className="px-4 py-2.5 text-[13px] text-center text-gray-600">
                    {row.Correo}
                  </td>
                  <td className="px-4 py-2.5 text-[13px] text-center">
                    <span
                      className={`px-3 py-1 rounded-full text-white text-xs font-medium ${row.Estado === "activo" ? "bg-[#00BB77]" : "bg-[#FB5252]"}`}
                    >
                      {row.Estado}
                    </span>
                  </td>
                  <td className="px-4 py-2.5 text-[13px] text-center">
                    <span
                      className={`px-3 py-1 rounded-full text-white text-xs font-medium ${row.Nivel === "alto" ? "bg-black" : row.Nivel === "medio" ? "bg-gray-500" : "bg-gray-300"}`}
                    >
                      {row.Nivel}
                    </span>
                  </td>
                  <td className="px-4 py-2.5 text-[13px] text-center text-gray-600">
                    {row.Nombre}
                  </td>
                  <td className="px-4 py-2.5 text-[13px] text-center">
                    <div className="flex justify-center items-center">
                      {[...Array(5)].map((_, index) => (
                        <div
                          key={index}
                          className={`w-5 h-5 rounded-full mx-1 ${
                            index < row.Progreso
                              ? row.Estado === "activo"
                                ? "bg-[#00BB77]"
                                : "bg-[#FB5252]"
                              : "bg-gray-300"
                          }`}
                        ></div>
                      ))}
                    </div>
                  </td>
                  <td className="px-4 py-2.5 text-[13px] text-center text-gray-600">
                    {row.Promedio}
                  </td>
                  <td className="px-4 py-2.5 text-[13px] text-center text-gray-600">
                    {row.created_at}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
